<template>
  <div class="dpv-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('DPV History')">
    </page-header>
    <div class="card content-wrapper p-2">
      <DpvTable/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import DpvTable from "./DpvTable";
  import {SOURCE_DPV_HISTORY_TABLE} from "../constants";

  const {mapActions} = createNamespacedHelpers('dpv/dpv');

  export default {
    name: "Dpv",
    components: {PageHeader, DpvTable},
    methods: {
      ...mapActions(['updateTableSource']),
    },
    async beforeMount() {
      await this.updateTableSource({source: SOURCE_DPV_HISTORY_TABLE});
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .dpv-list {
    @include list-view-wrapper;
  }
</style>
